import React from "react";
import { Modal } from "react-bootstrap";
import AssetLibrary from "./AssetLibrary";

const TITLE = { signature: "ลายเซ็น", stamp: "ตราปั๊ม" };

// modal คลังลายเซ็น/ตราปั๊มสำหรับหน้าแก้ PDF — เนื้อหาอยู่ใน AssetLibrary (ใช้ร่วมกับหน้าตั้งค่า)
// ไม่ใช้ closeButton ของ bootstrap เพราะ style.css กลับสี .btn-close เป็นสีขาว มองไม่เห็นบนหัว modal สีขาว
export default function AssetLibraryModal({ type, show, onHide, onPick }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Header>
        <Modal.Title as="h5" className="fw-semibold">คลัง{TITLE[type] || TITLE.signature}ของบริษัท</Modal.Title>
        <button type="button" className="btn btn-light btn-sm ms-auto rounded-3" onClick={onHide} title="ปิด" aria-label="ปิด">
          <i className="fa-solid fa-xmark" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <AssetLibrary type={type} onPick={onPick} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>ปิด</button>
      </Modal.Footer>
    </Modal>
  );
}
